export const TextEffectsOutlineOutViewerType =
  'wixui.TextEffectsOutlineOut' as const;
export const TestIds = {
  viewer: {
    container: 'TextEffectsOutlineOut-container',
    text: 'TextEffectsOutlineOut-text',
  },
} as const;
